<template>
    <v-img
        :src="imgSrc"
        contain class="my-5"
        :style="{position: 'relative', width: '100%', aspectRatio: '2 / 1'}"
        ref="pitchImg"
        >
        <div class="drawable" :style="drawableStyle">            
            <div v-for="area,i in areas" :key="`${i}-${area.id}`">
                <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs"
                    :key="area.id"
                    :color="area.selected && selectable ? 'red lighten-2' : 'grey lighten-2'"
                    class="area-toggle pa-0"
                    :style="getButtonStyle(area)"
                    @click="toggleArea(area)"
                    ></v-btn>
                </template>
                <span class="black--text body-1">{{ $t(`videoHighlights.areas.${area.name}`) }}</span>
                </v-tooltip>
            </div>
        </div>
    </v-img>
</template>

<script>
  export default {
    name: 'FieldAreaSelector',
    props: {
        fieldColor:{
            type:String,
            default: "green"
        },
        areas:{
            type:Array,
            required:true
        },
        selectable: {
            type: Boolean,
            default: true
        },
        isVertical: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        drawableStyle() {
            let top = this.isVertical ? 9 : 8.5;
            let left  = this.isVertical ? 22.5 : 18.75;
            let width = 100 - (left * 2);

            let heightOffset = this.isVertical ? 1.02 : 1;
            let height = (100 - (top * 2)) * heightOffset;
            return {
                position: 'absolute',
                top: `${top}%`,
                left: `${left}%`,
                width: `${width}%`,
                height: `${height}%`,
                minWidth: '10px',
                minHeight: '10px'
            };
        },
        imgSrc(){
            let verticalSrc = require(`@/assets/img/half_pitch_${this.fieldColor}.png`);
            let fullSrc = require(`@/assets/img/pitch_${this.fieldColor}.png`);
            return this.isVertical ? verticalSrc : fullSrc;
        }
    },
    data() {
      return {
      }
    },
    watch: {
    },
    methods:{
        getButtonStyle(area){
            const containerWidth = window.innerWidth;
            let scaleFactor = 1;

            if (containerWidth < 850) scaleFactor = 0.6;
            else if (containerWidth < 1200) scaleFactor = 0.8;

            const verticalFactor = 2;

            const width = area.x2 - area.x1;
            const height = area.y2 - area.y1;

            const left = this.isVertical ? 100-area.y2 : area.x1;
            const top = this.isVertical ? (100-area.x2) * verticalFactor : 100-area.y2;

            return {
                position: 'absolute',
                left: `${left}%`,
                top: `${top}%`,
                width: `${this.isVertical ? height : width}%`,
                height: `${this.isVertical ? width * verticalFactor : height}%`,
                minWidth: '10px',
                minHeight: '10px',
                opacity: 0.5,
            };
        },
        toggleArea(area){
            if(this.selectable){
                let newState = !area.selected;
                let areasMap = _.map(this.areas,(a) => {
                    if(a.id === area.id){
                        a.selected = newState;
                    }
                    return a;
                })
                this.$emit("areaToggle",areasMap)
            }
        },
        applyStateAll(state){
            _.forEach(this.areas,(a) => {
                a.selected = !state;
                this.toggleArea(a);
            })
            this.$forceUpdate()
        }
    }
  }
</script>

<style lang="scss">
.driblab-icon{
    object,img{
        *{

            color:inherit;
        }
    }
}
</style>
